import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function WebsiteCareComparisonTable() {
  const features = [{
    name: 'Hosting & Domain',
    essential: true,
    total: true,
    oneoff: false
  }, {
    name: 'SSL Certificate',
    essential: true,
    total: true,
    oneoff: false
  }, {
    name: 'Security Monitoring',
    essential: true,
    total: true,
    oneoff: 'One-time check'
  }, {
    name: 'Backups',
    essential: 'Monthly',
    total: 'Daily',
    oneoff: 'One-time backup'
  }, {
    name: 'WordPress Updates',
    essential: 'Monthly',
    total: 'Weekly',
    oneoff: 'One-time update'
  }, {
    name: 'Plugin/Theme Updates',
    essential: 'Monthly',
    total: 'Weekly',
    oneoff: 'One-time update'
  }, {
    name: 'Support Response Time',
    essential: '48 hours',
    total: '24 hours',
    oneoff: '72 hours'
  }, {
    name: 'Uptime Monitoring',
    essential: true,
    total: true,
    oneoff: false
  }, {
    name: 'Content Updates',
    essential: false,
    total: '1 hour per month',
    oneoff: false
  }, {
    name: 'SEO Optimization',
    essential: false,
    total: true,
    oneoff: false
  }, {
    name: 'Performance Tuning',
    essential: 'Quarterly',
    total: 'Monthly',
    oneoff: 'One-time'
  }, {
    name: 'Analytics Reports',
    essential: false,
    total: 'Monthly',
    oneoff: false
  }, {
    name: 'Malware Cleanup',
    essential: 'Additional fee',
    total: 'Included',
    oneoff: 'Additional fee'
  }, {
    name: 'Support Channels',
    essential: 'Email',
    total: 'Email & Phone',
    oneoff: 'Email'
  }];
  return <motion.div initial={{
    opacity: 0,
    height: 0
  }} animate={{
    opacity: 1,
    height: 'auto'
  }} exit={{
    opacity: 0,
    height: 0
  }} transition={{
    duration: 0.4,
    ease: 'easeInOut'
  }} className="mt-8 overflow-x-auto" style={{
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
  }} data-id="element-1251">
      <table className="min-w-full bg-white dark:bg-[#1E1E1E] rounded-lg overflow-hidden border border-[#D7E0E7] dark:border-gray-700" data-id="element-1252">
        <thead className="bg-[#212C34]" data-id="element-1253">
          <tr data-id="element-1254">
            <th className="py-4 px-6 text-left font-bold text-white border-b border-[#D7E0E7] dark:border-gray-700" data-id="element-1255">
              Feature
            </th>
            <th className="py-4 px-6 text-center font-bold text-white border-b border-[#D7E0E7] dark:border-gray-700" style={{
            backgroundColor: 'rgba(234, 247, 250, 0.1)'
          }} data-id="element-1256">
              Essential Care (£79/m)
            </th>
            <th className="py-4 px-6 text-center font-bold text-white border-b border-[#D7E0E7] dark:border-gray-700" style={{
            backgroundColor: 'rgba(255, 246, 229, 0.1)'
          }} data-id="element-1257">
              Total Growth (£299/m)
            </th>
            <th className="py-4 px-6 text-center font-bold text-white border-b border-[#D7E0E7] dark:border-gray-700" style={{
            backgroundColor: 'rgba(243, 245, 246, 0.1)'
          }} data-id="element-1258">
              One-off Fix (£150)
            </th>
          </tr>
        </thead>
        <tbody data-id="element-1259">
          {features.map((feature, index) => <tr key={index} className="transition-colors duration-200 hover:bg-[#E8F8FB] dark:hover:bg-gray-800/50" style={{
          backgroundColor: index % 2 === 0 ? '#F9FAFB' : '#EDF1F3'
        }} data-id="element-1260">
              <td className="py-4 px-6 border-b border-[#D7E0E7] dark:border-gray-700 font-semibold text-gray-900 dark:text-gray-100" data-id="element-1261">
                {feature.name}
              </td>
              <td className="py-4 px-6 text-center border-b border-[#D7E0E7] dark:border-gray-700" style={{
            backgroundColor: 'rgba(234, 247, 250, 0.3)'
          }} data-id="element-1262">
                {typeof feature.essential === 'boolean' ? feature.essential ? <CheckIcon size={20} className="text-green-500 mx-auto" data-id="element-1263" /> : <XIcon size={20} className="text-gray-400 mx-auto" data-id="element-1264" /> : <span className="text-gray-700 dark:text-gray-300 font-medium" data-id="element-1265">
                    {feature.essential}
                  </span>}
              </td>
              <td className="py-4 px-6 text-center border-b border-[#D7E0E7] dark:border-gray-700" style={{
            backgroundColor: 'rgba(255, 246, 229, 0.4)'
          }} data-id="element-1266">
                {typeof feature.total === 'boolean' ? feature.total ? <CheckIcon size={20} className="text-green-500 mx-auto" data-id="element-1267" /> : <XIcon size={20} className="text-gray-400 mx-auto" data-id="element-1268" /> : <span className="text-gray-700 dark:text-gray-300 font-medium" data-id="element-1269">
                    {feature.total}
                  </span>}
              </td>
              <td className="py-4 px-6 text-center border-b border-[#D7E0E7] dark:border-gray-700" style={{
            backgroundColor: 'rgba(243, 245, 246, 0.5)'
          }} data-id="element-1270">
                {typeof feature.oneoff === 'boolean' ? feature.oneoff ? <CheckIcon size={20} className="text-green-500 mx-auto" data-id="element-1271" /> : <XIcon size={20} className="text-gray-400 mx-auto" data-id="element-1272" /> : <span className="text-gray-700 dark:text-gray-300 font-medium" data-id="element-1273">
                    {feature.oneoff}
                  </span>}
              </td>
            </tr>)}
        </tbody>
      </table>
    </motion.div>;
}